<template>
  <div
    class="checkout"
  >
    <CheckoutSkeleton v-if="loading" />
    <div v-show="!loading">
      <CouponDetail
        class="checkout__coupon"
        :disabled="!discountAmountUSD"
      />
      <div class="summary-info">
        <Shipping />
        <p class="summary-info__title">
          Order Summary
        </p>
        <OrderSummary class="summary-info__summary" />
        <div
          v-if="hasProcessingSelected"
          class="pending-processing"
        >
          <div class="header">
            <Icon
              class="icon"
              name="icon-warning-outline"
            />
            Pending Processing ...
          </div>
          <div class="body">
            The platform will complete the processing within 1 business day. We have detected that some items require shipping cost confirmation. Please be patient.
          </div>
          <div
            @click="intercom.showNewMessage()"
            class="footer"
          >
            Free Expert Consultation Now!
          </div>
        </div>
        <div
          class="summary-info-undeliverable"
          v-else-if="hasUndeliverableSelected"
        >
          <p class="summary-info-undeliverable__title">
            Undeliverable Logistics
          </p>
          <p class="summary-info-undeliverable__desc">
            The logistics cannot be delivered at the moment. Please contact customer service for more information!
            &nbsp;<span @click="intercom.showNewMessage()">Contact us</span>
          </p>
        </div>
        <PayButton
          class="summary-info__buttons"
        />
      </div>
      <BulkDiscount class="checkout__discount" />
    </div>
  </div>
</template>

<script setup>
import CouponDetail from './CouponDetail.vue'
import PayButton from '@/views/Carts/components/PayButton.vue'
import Shipping from './Shipping.vue'
import { Icon } from '@/components/Icon'
import { useIntercom } from '@/hooks/useIntercom'
import OrderSummary from '@/views/Carts/components/OrderSummary.vue'
import { useOrder } from '@/views/Carts/hooks/useOrder'
import CheckoutSkeleton from './CheckoutSkeleton.vue'
import { useCart } from '@/views/Carts/hooks/useCart'
import BulkDiscount from './BulkDiscount.vue'

const { loading } = useCart()
const { discountAmountUSD, hasProcessingSelected, hasUndeliverableSelected } = useOrder()

const intercom = useIntercom()
</script>

<style lang='less' scoped>
.checkout {
  margin-top: 24px;
  position: sticky;
  top: 24px;

  .summary-info {
    padding: 20px 16px;
    background-color: #F8F8F8;
    border-radius: 8px;

    &__title {
      margin-top: 16px;
      font-family: mon-700;
      font-size: 14px;
      line-height: 18px;
    }

    &__summary {
      margin-top: 12px;
    }

    .pending-processing {
      margin-top: 16px;
      .header {
        display: flex;
        align-items: center;
        gap: 2px;
        color: #232323;
        font-size: 11px;
        font-family: mon-600;
        line-height: 14px;
        .icon {
          color: #DB7E25;
          font-size: 14px;
        }
      }
      .body {
        margin-top: 6px;
        color: #232323;
        font-size: 10px;
        font-family: mon-500;
        line-height: 14px;
      }
      .footer {
        color: #007EB3;
        margin-top: 4px;
        font-size: 11px;
        font-family: mon-600;
        text-decoration: underline;
        &:hover {
          color: var(--link-hover-color);
          cursor: pointer;
        }
      }
    }

    &__buttons {
      margin-top: 24px;

      :deep(.pay-buttons__paypal) {
        margin-bottom: -24px;
      }
    }

    &-undeliverable {
      padding-top: 16px;

      &__title {
        font-family: mon-600;
        font-size: 11px;
        line-height: 14px;
        color: #7A0505;
      }

      &__desc {
        margin-top: 6px;
        font-family: mon-500;
        font-size: 10px;
        line-height: 14px;
        color: #232323;

        > span {
          margin-top: 4px;
          display: block;
          font-family: mon-600;
          font-size: 11px;
          text-decoration: underline;
          color: #007EB3;
          cursor: pointer;
        }
      }
    }
  }

  &__coupon {
    margin-bottom: 8px;
  }

  &__discount {
    margin-top: 8px;
  }
}
</style>
